export default __webpack_public_path__ + "static/media/tasks.5f01d163.png";